// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.emailComposeCard {
  background: #fff;
  border-radius: 8px;
  padding: 30px;
  border: 1px solid #e5e5e5;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.composeLabel {
  display: block;
  color: #f44336;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 6px;
}

.composeInput {
  width: 100%;
  border: none;
  border-bottom: 1px solid #d6d6d6;
  padding: 8px 0;
  outline: none;
  font-size: 15px;
  background: transparent;
}

.composeInput:focus {
  border-bottom: 2px solid #2196f3;
}

.emailComposeCard .dropdownOption {
  width: 100%;
}

.mainTitle {
  font-size: 28px;
  font-weight: 600;
}

.btn-primary {
  background: #1e88e5;
  border: none;
  border-radius: 4px;
  padding: 8px 30px;
}

.btn-primary:hover {
  background: #1976d2;
}
.emailHighlight {
  display: inline-block;
  background: #e8f4ff;
  color: #0d6efd;
  padding: 8px 14px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #b6dcff;
}

`, "",{"version":3,"sources":["webpack://./src/Pages/email.css"],"names":[],"mappings":";;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,cAAc;EACd,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B","sourcesContent":["\n\n.emailComposeCard {\n  background: #fff;\n  border-radius: 8px;\n  padding: 30px;\n  border: 1px solid #e5e5e5;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n}\n\n.composeLabel {\n  display: block;\n  color: #f44336;\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 6px;\n}\n\n.composeInput {\n  width: 100%;\n  border: none;\n  border-bottom: 1px solid #d6d6d6;\n  padding: 8px 0;\n  outline: none;\n  font-size: 15px;\n  background: transparent;\n}\n\n.composeInput:focus {\n  border-bottom: 2px solid #2196f3;\n}\n\n.emailComposeCard .dropdownOption {\n  width: 100%;\n}\n\n.mainTitle {\n  font-size: 28px;\n  font-weight: 600;\n}\n\n.btn-primary {\n  background: #1e88e5;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 30px;\n}\n\n.btn-primary:hover {\n  background: #1976d2;\n}\n.emailHighlight {\n  display: inline-block;\n  background: #e8f4ff;\n  color: #0d6efd;\n  padding: 8px 14px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  border: 1px solid #b6dcff;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
